module.exports = __webpack_public_path__ + "static/media/recording.5076225a.svg";